import { Control } from 'react-hook-form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import type { EditUserFormData } from '../../../../../schema/user';

interface BasicInfoSectionProps {
  control: Control<EditUserFormData>;
}

export default function BasicInfoSection({ control }: BasicInfoSectionProps) {
  const { t, i18n } = useTranslation();
  const isRTL = useMemo(() => i18n.language === 'ar', [i18n.language]);

  return (
    <div className={cn('space-y-4', isRTL && 'rtl')}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={cn(isRTL && 'text-right')}>
                {t('users.edit.basicInfo.fullName')} *
              </FormLabel>
              <FormControl>
                <Input
                  placeholder={t('users.edit.basicInfo.placeholders.fullName')}
                  className={cn(isRTL && 'text-right')}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={cn(isRTL && 'text-right')}>
                {t('users.edit.basicInfo.emailAddress')} *
              </FormLabel>
              <FormControl>
                <Input
                  type="email"
                  placeholder={t('users.edit.basicInfo.placeholders.email')}
                  className={cn(isRTL && 'text-right')}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Phone and Department fields hidden as per user request */}
    </div>
  );
}
